
    import {onMounted, reactive, toRefs, computed, ref} from "vue";
    import EditorComponent from '@/components/editor/Editor.vue'
    import ApiMember from "@/request/apis/api_member";
    import {message} from "ant-design-vue/es";
    import PageUtil from "@/utils/page_util";
    import UploadUtil from "@/utils/upload_util";
    import {baseUrl} from "@/utils/config";
    import apiMember from "@/request/apis/api_member";
    interface IState {
        list:any,
        searches:any,
        total:any,
        visible:any,
        title:any,
        formState:any,
        type:any,
        levelData:any,
        artData:any
    }

    export default ({
        name: 'ArticleList',
        components: {EditorComponent},
        setup() {
            const state: IState = reactive({
                list:[],
                searches:{
                    page:PageUtil.pageNo,
                    limit:PageUtil.pageSize,
                    name:''
                },
                total:0,
                title:'',
                visible:false,
                artData:[],
                levelData:[],
                formState:{
                    id:'',
                    name:'',
                    growth_value:'',
                    image:'',
                    remark:'',
                    discount:''
                },
                type:''
            })

            const columns = [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align:'center'
                },
                {
                    title: '等级名称',
                    dataIndex: 'name',
                    key: 'name',
                    align:'center'
                },
                {
                    title: '编码',
                    dataIndex: 'code',
                    key: 'code',
                    align:'center'
                },
                {
                    title: '关联文章',
                    dataIndex: 'level',
                    key: 'level',
                    align:'center'
                },
                {
                    title: '成长值',
                    dataIndex: 'growth_value',
                    key: 'growth_value',
                    align:'center'
                },
                {
                    title: '等级图标',
                    dataIndex: 'image',
                    key: 'image',
                    align:'center'
                },
                {
                    title: '等级背景图',
                    dataIndex: 'background_image',
                    key: 'background_image',
                    align:'center'
                },
                {
                    title: '等级折扣',
                    dataIndex: 'discount',
                    key: 'discount',
                    align:'center'
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    align:'center'
                },
                {
                    title: '创建时间',
                    key: 'create_time',
                    dataIndex: 'create_time',
                    align:'center'
                },
                {
                    title: '修改时间',
                    key: 'update_time',
                    dataIndex: 'update_time',
                    align:'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150
                },
            ];
            const rules = {
                name: [{required: true, message: "请输入标签名称"}],
                remark: [{required: true, message: "请输入备注"}],
                growth_value: [{required: true, message: "请输入成长值"}],
                image: [{required: true, message: "请上传等级图标"}],
                discount: [{required: true, message: "请输入会员折扣"}],
                code: [{required: true, message: "请输入编码"}],
                article_id: [{required: true, message: "请选择"}],
                background_image: [{required: true, message: "请上传等级背景图"}],
            }
            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page,
                pageSize: state.searches.limit,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否启用pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));

            const getList = async()=>{
                const params = {...state.searches}
                const res = await ApiMember.LevelLists(params)
                if(res.error_code == 0){
                    const data:any = res.data
                    state.list = data.lists
                    state.total = data.count
                }else{
                    message.error(res.msg)
                }
            }

            const handleTableChange = (pages: any) => {
                state.searches.limit = pages.pageSize
                state.searches.page = pages.current
                getList()
            };

            const addApply = () =>{
                state.title = "新增会员等级"
                state.type = 1
                state.formState={
                    "name" :"",
                    "growth_value" : "",
                    "image" : "",
                    "background_image" : "",
                    "remark" : "",
                    "code":'',
                    "article_id":undefined,
                },
                    getLevel()
                    state.visible = true
            }
            const edit = (val) =>{
                state.title = "编辑会员等级"
                getLevel()
                state.type = 2
                state.formState={
                    "id":val.id,
                    "name" :val.name,
                    "growth_value" : val.growth_value,
                    "image" :val.image,
                    "background_image" : val.background_image,
                    "remark" : val.remark,
                    "discount" : val.discount,
                    "code" : val.code,
                    "article_id" : val.article_id == 0 ? undefined : val.article_id,
                }
                state.visible = true
            }
            const formRef = ref();
            const uploadHeaders = UploadUtil.uploadHeaders()
            let uploadAction = baseUrl + '/admin/upload/image'
            let uploadFormData = {cid: 10}
            const handleChange = ({file}: any) => {
                if (file.status === 'done' && file.response) {
                    const res = file.response
                    if (res && res.error_code === 0) {
                        const data = res.data
                        state.formState.image = data.uri
                    }
                }
            }
            const handleChange2 = ({file}: any) => {
                if (file.status === 'done' && file.response) {
                    const res = file.response
                    if (res && res.error_code === 0) {
                        const data = res.data
                        state.formState.background_image = data.uri
                    }
                }
            }

            const onSubmit = async () => {
                formRef.value.validate() .then(async() => {
                    const params = {...state.formState}
                    if (state.type == 1) {
                        const params = {...state.formState}
                        const res = await ApiMember.LevelAdd(params)
                        if(res.error_code == 0){
                            state.visible = false
                            getList()
                        }else{
                            message.error(res.msg)
                        }
                    } else {
                        const params = {...state.formState}
                        const res = await ApiMember.LevelEdit(params)
                        if(res.error_code == 0){
                            message.success(res.msg)
                            state.visible = false
                            getList()
                        }else{
                            message.error(res.msg)
                        }
                    }
                })
                    .catch((error: any) => {
                        console.log("error", error)
                    })
            }

            const onDel = async (item) => {
                const params = {id:item.id}
                const res = await apiMember.LevelDel(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        return
                    }
                    message.error(res.msg)
                }
            }

            const getLevel = async() => {
                const params = {}
                const res = await apiMember.getLevel(params)
                if (res) {
                    if (res.error_code === 0) {
                        state.levelData = res.data
                    }

                }
            }

            const getArt = async() => {
                const params = {}
                const res = await apiMember.articleCategoryLists(params)
                if (res) {
                    if (res.error_code === 0) {
                        state.artData = res.data
                        console.log(state.artData)
                    }

                }
            }
            const onSearch = () => {
                state.searches.page = 1
                state.searches.limit = PageUtil.pageSize
                getList()
            }
            const onReset = () => {
                state.searches.page = 1
                state.searches.limit = PageUtil.pageSize
                state.searches.name = ''
                getList()
            }
            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                getList,
                getLevel,
                getArt,
                uploadHeaders,
                uploadAction,
                onSearch,
                onReset,
                uploadFormData,
                pagination,
                columns,
                edit,
                onDel,
                formRef,
                handleChange,
                handleChange2,
                onSubmit,
                rules,
                addApply,
                handleTableChange
            }
        }
    })
